import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemStock\GetItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockController.php
* @route '/api/stock/item-stock/{item_stock}'
*/
const GetItemStockController = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemStockController.url(args, options),
    method: 'get',
})

GetItemStockController.definition = {
    methods: ["get","head"],
    url: '/api/stock/item-stock/{item_stock}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockController.php
* @route '/api/stock/item-stock/{item_stock}'
*/
GetItemStockController.url = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item_stock: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item_stock: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item_stock: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item_stock: typeof args.item_stock === 'object'
        ? args.item_stock.id
        : args.item_stock,
    }

    return GetItemStockController.definition.url
            .replace('{item_stock}', parsedArgs.item_stock.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockController.php
* @route '/api/stock/item-stock/{item_stock}'
*/
GetItemStockController.get = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemStockController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemStock\GetItemStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemStockController.php
* @route '/api/stock/item-stock/{item_stock}'
*/
GetItemStockController.head = (args: { item_stock: string | number | { id: string | number } } | [item_stock: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemStockController.url(args, options),
    method: 'head',
})

export default GetItemStockController